/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Box } from "@mui/system";
import { TextField } from "@mui/material";

export const StyledSearchContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginBottom: '16px',
})

export const StyledSearchBar = styled(TextField)({
  '&:hover': {
    "& .MuiOutlinedInput-notchedOutline": {
      border: '1px solid #2b4fb9 !important'
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
    borderRadius: '25px',
  },
  '& .MuiInputBase-root': {
    borderRadius: '25px',
    height: '2.4rem',
    paddingTop: '3px',
    fontSize: '15px',
    width: '253px !important',
    backgroundColor: "white",
  },
})

export const StatusContainer = styled(Box)(({ action }) => ({
  height: "22px",
  width: "100px",
  borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: `${getColorCode(action)}20`,
  color: getColorCode(action),
  fontSize: '0.775rem',
  padding: '2px',
}));

export const StyledActionContainer = styled('div')({
  display: 'flex',
  gap: '5px',
})

const getColorCode = (action) => {
  switch (action) {
    case 'guest_created':
      return '#39cd80'
    case 'merged':
      return '#61b2fa'
    case 'discarded':
      return '#f64246'
    case 'pending':
      return '#fba045'
    case 'conflict_tag':
      return '#61b2fa'
    default:
      return '#9e9e9e'
  }
}
